@if (canEdit) {
  <rask-container-block>
    <i class="viapunkt-color fas fa-lg fa-map-marker-plus" aria-hidden="true"></i>  Lägg till via-punkt genom att klicka i kartan
  </rask-container-block>
}
